{
	"title": "Matériaux disponibles",
	"showAllTitle": "Afficher tous les matériaux",
	"table": {
		"material": "Matériau",
		"invoicedQuantity": "Quantité facturée",
		"remainingForTransfer": "Restant pour la création de déclaration",
		"fetchError": "Impossible de récupérer les matériaux",
		"noMaterials": {
			"title": "Aucun matériau disponible",
			"description": "Vous n’avez actuellement aucun matériau disponible sur le {{productName}}. Veuillez contacter votre représentant commercial afin d’ajouter votre/vos contrat(s) à votre compte."
		}
	}
}
